import { matchModes } from '../constants'

export const matchModeOptions = [
  {
    label: 'Todos los valores seleccionados coinciden',
    value: matchModes.all,
  },
  {
    label: 'Alguno de los valores seleccionados coincide',
    value: matchModes.any,
  },
]
